if ($( "body" ).hasClass('error404')) {
	$( "body" ).addClass( 'transparent-header');
}